@use '@/sass/variables';

.FlexContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 13px;
  position: relative;
  box-sizing: border-box;
}

.ValuesContainer {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  overflow: hidden;
  min-height: 100%;
  padding-right: 2px;
}

.ValueChip {
  background-color: variables.$moon-gray;
  border-radius: 3px;
  padding: 1px 3px;
  margin: 1px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  justify-content: center;
}

.DropdownIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: variables.$moon-gray;
  width: 16px;
  cursor: default;

  &:hover {
    color: variables.$gray;
  }
}

.ValuesContainer {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  overflow: hidden;
  min-height: 100%;
}

.ValueChip {
  background-color: variables.$moon-gray;
  border-radius: 3px;
  padding: 1px 3px;
  margin: 1px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  justify-content: center;
  color: variables.$near-black;
}

.InvalidChip {
  border: 1px solid variables.$dark-red;
  background-color: variables.$dark-red-10;
}

/* Style for the dropdown icon when cell is in area selection */
:global(td.area) .DropdownIcon {
  color: variables.$light-gray;
}

.readOnly {
  background-color: variables.$near-white;
  padding: 0 16px;
}
